import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PageStateService } from '../services/page-state/page-state.service';

export const clearPageStateGuard: CanActivateFn = (route, state) => {
  const pageStateService = inject(PageStateService);
  const listKey = route.routeConfig?.path || 'default';
  pageStateService.clearPageState(listKey);
  return true;
};
